import { Row, Alert } from 'antd';
import { FC } from 'react';

interface MaintenanceKickoutMessageProps {
  timer: string;
}
export const MaintenanceKickoutMessage: FC<MaintenanceKickoutMessageProps> = (props) => {
  return (
    <Row justify={'center'} style={{ width: '100%', position: 'sticky', top: '0', zIndex: '1000' }}>
      <Alert
        style={{ width: '100%', textAlign: 'center', backgroundColor: 'rgba(255, 204, 51)' }}
        message={`Maintenance will begin in ${props.timer}. Please save your work and log out.`}
        type="warning"
        showIcon
      />
    </Row>
  );
};
